module.exports = __webpack_public_path__ + "nab.ttf?ae21f4f29df7ba213101930cad44fe1f";


//////////////////
// WEBPACK FOOTER
// ./~/@nsftx/nfont/css/fonts/nab.ttf
// module id = 318
// module chunks = 0